import { Component } from '@angular/core';
import {IconType} from "../../parts/fe-icon/fe-icon.component";
import {MatTableDataSource} from "@angular/material/table";
import {ArticleInterface} from "../../../interfaces/articles/article.interface";
import {ArticlesService} from "../../../services/articles/articles.service";
import {Projet} from "../../../interfaces/projet/Projet";

@Component({
  selector: 'app-projet-list',
  templateUrl: './projet-list.component.html',
  styleUrls: ['./projet-list.component.scss']
})
export class ProjetListComponent {

    protected readonly IconType = IconType;

    public loadingInProgress: boolean = false;
    public tableDataSource: MatTableDataSource<Projet> = new MatTableDataSource();

    public constructor(private articlesService: ArticlesService) {
        this.loadProjets();
    }

    public loadProjets() {
        this.articlesService.getProjets({projets: [1, 2]}).subscribe(value => {
            this.tableDataSource.data = value;
        });
    }

}
